const LoanProgressBar = ({ current, type }) => {

    const stages = ["initial", 'approved', "pendingDisbursement", "active", "completed"];
    const stagesFull = ["In Review", 'Attach Facility Letter', "Pending Disbursement", "Active", "Completed"];

    const currentStageIndex = stages.indexOf(current);
    const progressBarWidth = Math.max(0, (100 / (stages.length - 1)) * currentStageIndex);

    // Add a space before capital letters: "SalariedAdvance" → "Salaried Advance"
    const prettyType = typeof type === "string" ? type.replace(/([a-z])([A-Z])/g, "$1 $2") : type;

    return (
        <div className="w-full mb-10 rounded-2xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-dark-bg p-5 md:p-6 shadow-sm">
            <div className="flex items-start justify-between gap-4 mb-6">
                <div>
                    <p className="text-xs uppercase tracking-wide font-semibold text-slate-400 dark:text-slate-500">Application Progress</p>
                    <h3 className="mt-1 text-lg font-semibold text-heading dark:text-slate-100">{prettyType}</h3>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                    <span className="text-2xl font-semibold text-emerald-500 tabular-nums">{Math.round(progressBarWidth)}%</span>
                    <span className="text-xs text-slate-400 dark:text-slate-500 mt-2">complete</span>
                </div>
            </div>

            {/* Progress bar */}
            <div className="relative w-full">
                <div className="h-2 w-full bg-slate-100 dark:bg-dark-page rounded-full overflow-hidden">
                    <div
                        className="h-full bg-gradient-to-r from-emerald-400 to-emerald-500 rounded-full transition-all duration-500 ease-out"
                        style={{ width: `${progressBarWidth}%` }}
                    />
                </div>

                {/* Step markers on top of the bar */}
                <div className="absolute inset-0 flex items-center justify-between px-0">
                    {stages.map((_, index) => {
                        const isCompleted = index < currentStageIndex;
                        const isCurrent = index === currentStageIndex;
                        return (
                            <div key={index} className="relative">
                                <div
                                    className={[
                                        "w-4 h-4 rounded-full border-2 flex items-center justify-center transition-colors",
                                        isCompleted || isCurrent
                                            ? "bg-emerald-500 border-emerald-500"
                                            : "bg-white dark:bg-dark-bg border-slate-200 dark:border-slate-600",
                                    ].join(" ")}
                                >
                                    {isCompleted && (
                                        <svg viewBox="0 0 20 20" fill="currentColor" className="w-2.5 h-2.5 text-white">
                                            <path fillRule="evenodd" d="M16.704 5.296a1 1 0 010 1.414l-7.997 8a1 1 0 01-1.414 0L3.293 10.71a1 1 0 011.414-1.414l3.293 3.293 7.29-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                        </svg>
                                    )}
                                </div>
                                {isCurrent && index !== stages.length - 1 && (
                                    <span className="absolute inset-0 rounded-full bg-emerald-400/40 animate-ping" />
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Step labels */}
            <div className="hidden md:flex justify-between mt-5 gap-2">
                {stagesFull.map((stage, index) => {
                    const isCompleted = index < currentStageIndex;
                    const isCurrent = index === currentStageIndex;
                    return (
                        <div
                            key={index}
                            className={[
                                "flex-1 text-center text-xs font-medium",
                                isCompleted ? "text-emerald-500" : "",
                                isCurrent ? "text-emerald-600 dark:text-emerald-400 font-semibold" : "",
                                !isCompleted && !isCurrent ? "text-slate-400 dark:text-slate-500" : "",
                            ].join(" ")}
                        >
                            {stage}
                        </div>
                    );
                })}
            </div>

            {/* Mobile current step label */}
            <div className="md:hidden mt-4 text-sm">
                <span className="text-slate-500 dark:text-slate-400">Current stage: </span>
                <span className="font-semibold text-emerald-600 dark:text-emerald-400">
                    {stagesFull[currentStageIndex] ?? "—"}
                </span>
            </div>
        </div>
    );
};

export default LoanProgressBar;
